export enum EventMode {
  Create = 'create',
  Edit = 'edit'
}
